import { ReactNode, useState, useEffect } from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import { mockInformations } from '../../shared/data/mockHeaderData';
import { getPublicCategories } from '../../shared/api/categories';
import { Category } from '../../shared/types/header';
import './UserLayout.css';

interface UserLayoutProps {
  children: ReactNode;
  blogName?: string;
  blogNameEn?: string;
}

/**
 * ユーザー向けページの共通レイアウトコンポーネント
 * ヘッダーと通知バナーを含む共通のレイアウトを提供
 */
const UserLayout: React.FC<UserLayoutProps> = ({
  children,
  blogName = 'Version0.1',
  blogNameEn = 'Version0.1',
}) => {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoriesResponse = await getPublicCategories();
        // orderでソート
        const sortedCategories = [...categoriesResponse.categories].sort((a, b) => 
          (a.order || 0) - (b.order || 0)
        );
        setCategories(sortedCategories);
      } catch (err) {
        // カテゴリー取得エラーは無視（オプショナル）
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="user-layout">
      <SiteHeader
        blogName={blogName}
        blogNameEn={blogNameEn}
        categories={categories}
        informations={mockInformations}
      />
      <div className="user-layout__main">{children}</div>
      <SiteFooter blogName={blogName} />
    </div>
  );
};

export default UserLayout;

